import { CRUDService } from '@/services/CRUD'
import type { NotificationItem } from './types'

export class NotificationService extends CRUDService {
  static async list(accountId: string) {
    return await this.handlePromise<NotificationItem[]>(
      this.api.get(`/company/${accountId}/notification`, {
        params: {
          sort: 'createdDate,desc',
        },
      })
    )
  }

  static async setRead(
    accountId: string,
    notificationId: string,
    read: boolean
  ) {
    return await this.handlePromise(
      this.api.put(
        `/company/${accountId}/notification/${notificationId}`,
        null,
        {
          params: { read },
        }
      )
    )
  }

  static async setAllRead(accountId: string, read: boolean) {
    return await this.handlePromise(
      this.api.put(`/company/${accountId}/notification`, null, {
        params: { read },
      })
    )
  }

  static async read(accountId: string, notificationId: string) {
    return await this.setRead(accountId, notificationId, true)
  }

  static async unread(accountId: string, notificationId: string) {
    return await this.setRead(accountId, notificationId, false)
  }

  static async readAll(accountId: string) {
    return await this.setAllRead(accountId, true)
  }

  static async unreadAll(accountId: string) {
    return await this.setAllRead(accountId, false)
  }
}
